import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';
import { Design } from '@/model/document2/page/surface/design/design';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';

// 新規レイヤーコマンド
export class NewLayerCommand implements ICommandBase
{
    private newLayer! : Layer;
    private parent! : GroupLayer;
    private design! : Design;
    private doneCallback! : () => void;

    private currentLayer : Layer | null;
    private selectLayers : Array<Layer> = new Array();

    constructor(newLayer : Layer, parent : GroupLayer, design : Design, doneCallback : () => void)
    {
        this.newLayer = newLayer;
        this.parent = parent;
        this.design = design;
        this.doneCallback = doneCallback;
        // カレントレイヤー保持
        this.currentLayer = design.currentLayer;
        // 選択状態保持
        for(var selectLayer of design.selectLayers)
        {
            this.selectLayers.push(selectLayer);
        }
    }

    public do() : void
    {
        // レイヤー追加
        this.parent.addLayer(this.newLayer);
        // 新規レイヤーにカレントを移す
        this.design.currentLayer = this.newLayer;
        // 新規レイヤーのみを選択状態にする
        this.design.clearSelectLayers();
        this.design.addSelectLayer(this.newLayer);
        // 親のレイヤーは強制で開く
        this.parent.isExpanded = true;

        // 連番文字対応
        if(this.newLayer instanceof NumberLayer) { this.newLayer.updateDocument(true); }

        this.doneCallback();
    }

    public undo() : void
    {
        // カレントを元に戻す
        this.design.currentLayer = this.currentLayer;
        // 選択状態を元に戻す
        this.design.clearSelectLayers();
        for(var selectLayer of this.selectLayers)
        {
            this.design.addSelectLayer(selectLayer);
        }
        // レイヤー削除
        this.parent.removeLayer(this.newLayer);

        // 連番文字対応
        if(this.newLayer instanceof NumberLayer) { this.newLayer.updateDocument(false); }

        this.doneCallback();
    }

    public redo() : void
    {
        // レイヤー追加
        this.parent.addLayer(this.newLayer);
        // 新規レイヤーにカレントを移す
        this.design.currentLayer = this.newLayer;
        // 新規レイヤーのみを選択状態にする
        this.design.clearSelectLayers();
        this.design.addSelectLayer(this.newLayer);
        // 親のレイヤーは強制で開く
        this.parent.isExpanded = true;

        // 連番文字対応
        if(this.newLayer instanceof NumberLayer) { this.newLayer.updateDocument(true); }

        this.doneCallback();
    }
}